import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    myself: null,
    users: [],
    roles: [],
    snack: {
      visible: false,
      mess: '',
      type: '',
    },
    preview: {
      visible: false,
      src: '',
    },
    selected: {
      visible: false,
      items: [],
      ref: null,
      add: false,
    },
    loading: false,
    itemsClip: [],
  },
  getters: {
    myself(state) {
      return state.myself
    },
    users(state) {
      return state.users
    },
    roles(state) {
      return state.roles
    },
    snack(state) {
      return state.snack
    },
    preview(state) {
      return state.preview
    },
    selected(state) {
      return state.selected
    },
    loading(state) {
      return state.loading
    },
    itemsClip(state) {
      return state.itemsClip
    },
  },
  mutations: {
    setMyself(state, payload) {
      if (state.myself != null && state.myself.id != payload.myself.id) return
      state.myself = payload.myself
    },
    setUsers(state, payload) {
      state.users = payload.users
    },
    setRoles(state, payload) {
      state.roles = payload.roles
    },
    setSnack(state, payload) {
      state.snack = payload.snack
    },
    setPreview(state, payload) {
      state.preview = payload.preview
    },
    setSelected(state, payload) {
      state.selected = payload.selected
    },
    setLoading(state, payload) {
      state.loading = payload.loading
    },
    setItemsClip(state, payload) {
      state.itemsClip = payload.itemsClip
    },
  },
  actions: {
    updateMyself({ commit }, myself) {
      commit('setMyself', { myself })
    },
    updateUsers({ commit }, users) {
      commit('setUsers', { users })
    },
    updateRoles({ commit }, roles) {
      commit('setRoles', { roles })
    },
    updateSnack({ commit }, snack) {
      commit('setSnack', { snack })
    },
    updatePreview({ commit }, preview) {
      commit('setPreview', { preview })
    },
    updateSelected({ commit }, selected) {
      commit('setSelected', { selected })
    },
    updateLoading({ commit }, loading) {
      commit('setLoading', { loading })
    },
    updateItemsClip({ commit }, itemsClip) {
      commit('setItemsClip', { itemsClip })
    },
  }
})
